import BaseUseCase from "../../../base_use_case.js";
import Routes from "../../../../admin/routes.js";
class ListProjectUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/projects/projects`,
      params: params
    }).then((result) => {
      let { data, headers } = result; 
      let { projects } = data; 

      projects = projects.map((project) => {
        return {
          ...project,
          key: project.slug,
          itemLink: Routes.project(project)
        }
      })
      data.list = projects;
      return {
        data: data,
        headers: headers
      }
    })
  }
}

const instance = new ListProjectUseCase();
export default instance;